import PermissionChecker from '@/security/permission-checker';
import Permissions from '@/security/permissions';

export class RealEstateRegisterPermissions {
    constructor(currentUser) {
        const permissionChecker = new PermissionChecker(
            currentUser,
        );

        this.read = permissionChecker.match(
            Permissions.values.realEstateRegisterRead,
        );
    }
}
